import {FC} from 'react';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import TooltipWrapper from 'components/Tooltip';
import {c} from 'ttag';
import {PermissionResponse} from 'types/permissions';

export type NavigationTabsTeamButtonPermissions = {
    groupsAndRoles: PermissionResponse;
    members: PermissionResponse;
    revoked: PermissionResponse;
};

type NavigationTabsTeamProps = NavigationTabsPropsHelper &
    NavigationTabsTeamButtonPermissions;

const NavigationTabsTeam: FC<NavigationTabsTeamProps> = ({
    className,
    groupsAndRoles,
    members,
    revoked,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        <TooltipWrapper message={members.failureReason}>
            <BaseNavigationTabsButton
                disabled={!members.allowed}
                href={window.Urls.employee_list_view()}
                label={c('component').t`Members`}
                name="members"
            />
        </TooltipWrapper>
        <TooltipWrapper message={groupsAndRoles.failureReason}>
            <BaseNavigationTabsButton
                disabled={!groupsAndRoles.allowed}
                href={window.Urls.team_list_view()}
                label={c('component').t`Groups & Roles`}
                name="groupsAndRoles"
            />
        </TooltipWrapper>
        <TooltipWrapper message={revoked.failureReason}>
            <BaseNavigationTabsButton
                disabled={!revoked.allowed}
                href={window.Urls.revoked_list_view()}
                label={c('component').t`Revoked`}
                name="revoked"
            />
        </TooltipWrapper>
    </BaseNavigationTabs>
);

export default NavigationTabsTeam;
